<script setup lang="ts">
import type { RiskAxisLevel } from '@/models/api-generated'

const props = defineProps<{
	type: 'horizontal' | 'vertical'
	isEdit: boolean
}>()

const model = defineModel<RiskAxisLevel>({ required: true })
</script>

<template>
	<div class="flex-fill d-flex overflow-hidden">
		<div
			class="flex-fill d-flex flex-column p-2"
			:class="{
				'justify-content-evenly': props.type === 'vertical',
				'align-items-center': props.type === 'vertical',
			}"
		>
			<div class="w-100 text-center overflow-scroll">
				<template v-if="!props.isEdit">
					<div class="text-truncate fw-bold">{{ model.title }}</div>
					<div class="desc">{{ model.description }}</div>
				</template>

				<template v-else>
					<input
						:data-test="`axis-title-${props.type}`"
						class="form-control w-100 fw-bold"
						type="text"
						v-model="model.title"
						maxlength="50"
					/>
					<textarea
						:data-test="`axis-description-${props.type}`"
						class="form-control w-100"
						v-model="model.description"
						maxlength="700"
					></textarea>
				</template>
			</div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.flex-column
  min-width: 0
  overflow: hidden

.desc
  border-bottom: 1px dashed gray
  white-space: pre-wrap

.text-center
  font-size: 1vw

.overflow-hidden
  max-height: 100%
</style>
